import { combineReducers } from 'redux';
import alertReducer from '@store/reducers/alertReducer';
import authReducer from '@store/reducers/authReducer';
import funnelReducer from '@store/reducers/funnelReducer';
import nrAccountReducer from '@store/reducers/nrAccountReducer';
import ordersReducer from '@store/reducers/ordersReducers';
import referralReducer from '@store/reducers/referralReducer';
import reqDataReducer from '@store/reducers/reqDataReducer';
import resDataReducer from '@store/reducers/resDataReducer';
import usersReducer from '@store/reducers/usersReducer';
import providerHolidaysReducer from '@store/reducers/providerHolidaysReducer';
import workflowReducer from '@store/reducers/workflowReducer';
import kycReducer from '@store/reducers/kycReducer';
import thunesReducer from '@store/reducers/thunesReducer';
import sourceAccountReducer from '@store/reducers/sourceAccountReducer';
import jobsReducer from '@store/reducers/jobsReducer';
import configReducer from '@store/reducers/configReducer';
import userReferralReducer from '@store/reducers/userReferralReducer';
import nreNroReducer from '@store/reducers/nreNroReducer';
import ticketsReducer from '@store/reducers/ticketsReducer';
import cxUsersReducer from '@store/reducers/cxUsersReducer';
import workflowReducerV2 from '@store/reducers/workflowReducerV2';
import nronboardReducer from '@store/reducers/nronboardreducer';
import yblDetailsReducer from '@store/reducers/yblReducer';
import orderScreenConfigReducer from '@store/reducers/orderScreenConfigReducer';
import rdaReducer from '@store/reducers/rdaReducer';
import manualPayoutBatchReducer from '@store/reducers/manualPayoutBatchReducer';
import accessManagementReducer from '@store/reducers/accessManagementReducer';
import baerscrestOpsReducer from '@store/reducers/baerscrestReducer';
import falconReducer from '@store/reducers/falconReducer';
import rdaDashboardReducer from '@store/reducers/rdaDashboardReducer';
import payoutReducer from '@store/reducers/payoutReducer';
import falconDashboardReducer from '@store/reducers/falconDashboardReducer';
import beneficiaryVerificationDashboardReducer from '@store/reducers/beneficiaryVerificationDashboardReducer';
import rfiReducer from '@store/reducers/rfiReducer';
import luluRefundsDashboardReducer from '@store/reducers/luluRefundsDashboardReducer';
import reconDashboardReducer from '@store/reducers/reconDashboardReducer';
import settlementTimelineManagerReducer from '@store/reducers/settlementTimelineManagerReducer';
import settlementServiceDashboardReducer from '@store/reducers/settlementServiceDashboardReducer';
import luluBulkReducer from '@store/reducers/luluBulkSync';
import rewardsV2Reducer from '@store/reducers/rewardsV2Reducer';
import sardineOnHoldReducer from '@store/reducers/sardineOnHoldReducer';
import bbpsReducer from '@store/reducers/bbpsReducer';
import gomsOrderDashboardReducer from '@store/reducers/gomsDashboardReducer';
import caseInvestigationManagerReducer from '@store/reducers/caseInvestigationManagerReducer';
import outboundCallingReducer from '@store/reducers/outboundCallingReducer';
import libraDashboardReducer from '@store/reducers/libraDashboardReducer';
import fxServiceManagerReducer from '@store/reducers/fxServiceManagerReducer';
import fastTransferManagerReducer from '@store/reducers/fastTransferManagerReducer';


const rootReducer = combineReducers({
  alert: alertReducer,
  auth: authReducer,
  users: usersReducer,
  orders: ordersReducer,
  reqData: reqDataReducer,
  resData: resDataReducer,
  funnel: funnelReducer,
  referral: referralReducer,
  nrAccount: nrAccountReducer,
  providerHolidays: providerHolidaysReducer,
  workflow: workflowReducer,
  kyc: kycReducer,
  thunes: thunesReducer,
  sourceAccount: sourceAccountReducer,
  jobs: jobsReducer,
  config: configReducer,
  userReferral: userReferralReducer,
  nreNro: nreNroReducer,
  tickets: ticketsReducer,
  cxUsers: cxUsersReducer,
  workflowsV2: workflowReducerV2,
  nronboard: nronboardReducer,
  yblDetails: yblDetailsReducer,
  orderScreenConfig: orderScreenConfigReducer,
  rda: rdaReducer,
  manualPayoutBatch: manualPayoutBatchReducer,
  accessManagement: accessManagementReducer,
  baerscrestOps: baerscrestOpsReducer,
  falconOps: falconReducer,
  rdaDashboard: rdaDashboardReducer,
  payoutDashboard: payoutReducer,
  falconDashboard: falconDashboardReducer,
  beneficiaryVerificationDashboard: beneficiaryVerificationDashboardReducer,
  rfiDetails: rfiReducer,
  luluRefundsDashboard: luluRefundsDashboardReducer,
  reconDashboard: reconDashboardReducer,
  settlementTimelineManager: settlementTimelineManagerReducer,
  settlementServiceDashboard: settlementServiceDashboardReducer,
  luluBulkSync: luluBulkReducer,
  rewardsV2: rewardsV2Reducer,
  sardineOnHold: sardineOnHoldReducer,
  bbps: bbpsReducer,
  gomsOrderDashboard: gomsOrderDashboardReducer,
  caseInvestigationManager: caseInvestigationManagerReducer,
  outboundCalling: outboundCallingReducer,
  libraDashboard: libraDashboardReducer,
  fxServiceManager: fxServiceManagerReducer,
  fastTransferManager: fastTransferManagerReducer

});

export default rootReducer;
